import { FC, memo, ReactNode } from 'react';

export interface IMessageWrapperProps {
  className?: string,
  isVisible: boolean,
  children: ReactNode
}

const MessageWrapper: FC<IMessageWrapperProps> = ({ className = '', isVisible, children }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={`flex items-center rounded-lg p-1.5 min-h-[32px] ${className}`}>
      {children}
    </div>
  );
};

export default memo(MessageWrapper);
